const resources = {
    selectSubstitute: 'Sélectionnez un article de remplacement',
    selectSubstituteFor: 'Sélectionnez un article de remplacement pour :',
    recommendedSubstitutions: 'Substitutions recommandées :',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    outOfStock: 'Rupture de stock'
};

module.exports = function getResource(label) {
    return resources[label];
};
